import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import PHPSvgColor from '../assets/php.svg';

export const PHPColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-php" className={cx('sdkIcon', className)} size={size} {...props}>
    <PHPSvgColor />
  </LegacyIcon>
);
